import React from 'react';

import TrelloAttachmentIcon from '../../icons/TrelloAttachmentIcon';

import IconBadge from './IconBadge';

const TrellotrelloAttachmentsBadge = ({ numAttachments = 0 }) => (
  <IconBadge icon={<TrelloAttachmentIcon />}>{numAttachments}</IconBadge>
);

export default TrellotrelloAttachmentsBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/TrelloAttachmentsBadge.js